var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIssueType(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8379_40195)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 5.5H6C5.46957 5.5 4.00302 5.50002 4.00302 5.50002C4.00302 5.50002 4 6.96957 4 7.5V19.5C4 20.0304 4 21.5 4 21.5C4 21.5 5.46957 21.5 6 21.5H11.697",
    stroke: "#212121",
    strokeWidth: 2,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 12.5V7.5C18 6.96957 18 5.5 18 5.5C18 5.5 16.5304 5.5 16 5.5H14",
    stroke: "#212121",
    strokeWidth: 2,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 3.5H10C8.89543 3.5 8 4.39543 8 5.5C8 6.60457 8.89543 7.5 10 7.5H12C13.1046 7.5 14 6.60457 14 5.5C14 4.39543 13.1046 3.5 12 3.5Z",
    stroke: "#212121",
    strokeWidth: 2,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 11.5H12",
    stroke: "#212121",
    strokeWidth: 2,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 15.5H11",
    stroke: "#212121",
    strokeWidth: 2,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 20.5C17.8807 20.5 19 19.3807 19 18C19 16.6193 17.8807 15.5 16.5 15.5C15.1193 15.5 14 16.6193 14 18C14 19.3807 15.1193 20.5 16.5 20.5Z",
    stroke: "#212121",
    strokeWidth: 2,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5 20L21 22.5",
    stroke: "#212121",
    strokeWidth: 2,
    strokeLinecap: "square"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8379_40195"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIssueType);
export default __webpack_public_path__ + "static/media/issue-type.5448165c159bd3cfa5d27fe761045607.svg";
export { ForwardRef as ReactComponent };